import React from 'react';
import styles from './Separator.module.css';

type SeparatorProps = {
  text?: string;
  className?: string;
};

const Separator = ({ text = 'No matches', className }: SeparatorProps) => {
  return (
    <div className={`${styles.separator} ${className || ''}`}>
      <span className={styles.separatorText}>{text}</span>
    </div>
  );
};

export default Separator;
